export const STATUS = {
  DEFAULT: "default",
  VERIFYING: "verifying",
  AVAILABLE: "available",
  UNAVAILABLE: "unavailable",
  ERROR: "error"
};
